import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["error"];
import { memoizeDeep } from "../common/utilities";
const setTheme = memoizeDeep(function (_ref) {
  let {
    fileinput
  } = _ref;
  let cssRoot = {},
      cssLabelContainer = {},
      cssConfirmationWrapper = {},
      cssClearButton = {},
      cssTriggerContainer = {},
      cssTriggerContentBox = {},
      cssFileDetails = {},
      cssProgressBarWrapper = {},
      cssProgressBarContentBox = {},
      cssFileSuccessWrapper = {},
      cssTriggerButton = {},
      cssFooter = {},
      cssFooterError = {};

  if (fileinput) {
    cssRoot = fileinput.root;
    cssLabelContainer = fileinput.labelContainer;
    cssConfirmationWrapper = fileinput.confirmationWrapper;
    cssClearButton = fileinput.clearButton;
    cssTriggerContainer = fileinput.triggerContainer;
    cssTriggerButton = fileinput.triggerButton;
    cssProgressBarWrapper = fileinput.progressBarWrapper;
    cssProgressBarContentBox = fileinput.progressBarContentBox;
    cssFileSuccessWrapper = fileinput.fileSuccessWrapper;
    cssTriggerContentBox = fileinput.triggerContentBox;
    cssFileDetails = fileinput.detailsContainer;

    const _fileinput$footer = fileinput.footer,
          {
      error: errorFooterStyles
    } = _fileinput$footer,
          commonFooterStyles = _objectWithoutProperties(_fileinput$footer, _excluded);

    cssFooter = commonFooterStyles;
    cssFooterError = errorFooterStyles;
  }

  return {
    cssRoot,
    cssLabelContainer,
    cssConfirmationWrapper,
    cssClearButton,
    cssTriggerContainer,
    cssTriggerContentBox,
    cssFileDetails,
    cssProgressBarWrapper,
    cssProgressBarContentBox,
    cssFileSuccessWrapper,
    cssTriggerButton,
    cssFooter,
    cssFooterError
  };
});
export default function (_ref2) {
  var _theme$components;

  let {
    theme
  } = _ref2;
  const fileinput = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.fileinput;
  return setTheme({
    fileinput
  });
}